import React from "react";
import { CONFIG } from "../const/config";
import { TechIcons } from "../common/misc";

const PersonalItem = ({ details, id }) => {
  console.log({ details });

  return (
    <div className="col-md-6 personal-project" id={id}>
      <div className="card card-2 text-center">
        <div className="card__top">
          <a href="#">
            <img alt="" src={CONFIG.projectBasePath + details.image} />
          </a>
        </div>
        <div className="card__body">
          <h4>{details.title}</h4>
          {details.tech.map((tech, i) => (
            <TechIcons name={tech} key={`${id}-tech-logo-${i}`} />
          ))}

          <p>{details.description}</p>
        </div>
        <div className="card__bottom text-center d-flex flex-row justify-content-center align-items-center">
          {details.links ? (
            details.links.map((link, i) => (
              <div
                className="card__action"
                key={`card-action-${i}-personal${id}`}
              >
                <a href={link.url} target="blank">
                  <span className="h6 inline-block type--uppercase">
                    {link.label}
                  </span>
                  <i className={link.icon}></i>
                </a>
              </div>
            ))
          ) : details.message ? (
            <div className="card__action message">
              <p className="h5  text-muted">{details.message}</p>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default PersonalItem;
